import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async fetchEndUseSortById (_, { endUseSortId }) {
    const response = await ApiServer.get('endUseSorts', endUseSortId)
    return response.data
  },

  async fetchEndUseSorts (context) {
    context.commit('setEndUseSortsLoading', true)
    const response = await ApiServer.get('endUseSorts')
    const sortedData = response.data.sort((a, b) => a.name.localeCompare(b.name))
    context.commit('setEndUseSorts', sortedData)
    context.commit('setEndUseSortsLoading', false)
    return sortedData
  },

  async deleteEndUseSort (context, endUseSortId) {
    const response = await ApiServer.delete(`endUseSorts/${endUseSortId}`)
    context.commit('removeEndUseSort', endUseSortId)
    return response.data
  },

  async createEndUseSort (context, endUseSort) {
    const response = await ApiServer.post('endUseSorts', endUseSort)
    context.commit('addEndUseSort', response.data)
    return response.data
  },

  async updateEndUseSort (context, endUseSort) {
    const response = await ApiServer.put(`endUseSorts/${endUseSort.endUseSortId}`, endUseSort)
    context.commit('updateHarvestType', response.data)
    return response.data
  }
}
